import { z } from 'zod';
import { didSchema } from '../validation/primitives.js';

export const POLICY_ACTIONS = [
  'ISSUE',
  'TRANSFER_SEND',
  'TRANSFER_RECEIVE',
  'TRADE_ORDER',
  'CLAIM_DIVIDEND',
] as const;
export type PolicyAction = (typeof POLICY_ACTIONS)[number];

export const POLICY_DECISIONS = ['PERMITTED', 'DENIED', 'REQUIRES_MANUAL_REVIEW'] as const;
export type PolicyDecision = (typeof POLICY_DECISIONS)[number];

export const KYC_TIERS = ['UNVERIFIED', 'BASIC', 'ACCREDITED', 'INSTITUTIONAL'] as const;
export type KycTier = (typeof KYC_TIERS)[number];

export const policyDecisionRecordSchema = z.object({
  decisionId: z.string().uuid(),
  instrumentId: z.string().min(1),
  subjectDid: didSchema,
  action: z.enum(POLICY_ACTIONS),
  decision: z.enum(POLICY_DECISIONS),
  denialReasonCode: z.string().optional(),
  policyVersion: z.number().int().positive(),
  evaluatedJurisdiction: z.string().length(2),
  kycTier: z.enum(KYC_TIERS),
  expiresAt: z.number().int().positive(), // Epoch seconds
  complianceSignerKid: z.string().min(1),
  signature: z.string().min(64),
});

export type PolicyDecisionRecord = z.infer<typeof policyDecisionRecordSchema>;

export interface PolicyDecisionRecordWire {
  decisionId: string;
  instrumentId: string;
  subjectDid: string;
  action: PolicyAction;
  decision: PolicyDecision;
  denialReasonCode?: string | null;
  policyVersion: number;
  evaluatedJurisdiction: string;
  kycTier: KycTier;
  expiresAt: number;
  complianceSignerKid: string;
  signature: string;
}
